import { render } from "./EditArtikelEvent.vue?vue&type=template&id=0db931c5"
import script from "./EditArtikelEvent.vue?vue&type=script&lang=js"
export * from "./EditArtikelEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__